export const EDGE_TOOLBAR_HEIGHT = 26;
export const EDGE_TOOLBAR_FONT_SIZE = 13;
export const EDGE_TOOLBAR_LINE_HEIGHT = 13;
export const EDGE_TOOLBAR_ICON_SIZE = 15;
export const PINNED_TOOLBAR_HEIGHT = 28;
export const PINNED_TOOLBAR_FONT_SIZE = 13;
export const PINNED_TOOLBAR_ICON_SIZE = 16;
export const PINNED_TOOLBAR_LINE_HEIGHT = 13;
export const TOOLBAR_DROPDOWN_ICON_BUTTON_WIDTH = 22;
export const toolbarIconButtonSizeVariants = {
  pinned: {
    height: `${PINNED_TOOLBAR_HEIGHT}px`,
    width: `fit-content`,
    fontSize: `${PINNED_TOOLBAR_ICON_SIZE}px`,
    lineHeight: `${PINNED_TOOLBAR_LINE_HEIGHT}px`
  },
  edge: {
    height: `${EDGE_TOOLBAR_HEIGHT}px`,
    width: `fit-content`,
    fontSize: `${EDGE_TOOLBAR_ICON_SIZE}px`,
    lineHeight: `${EDGE_TOOLBAR_LINE_HEIGHT}px`
  }
};
export const ROUNDED_BUTTON_HEIGHT = 42;
export const DEFAULT_RESPONSIVE_SIZE = 'default';
export const MEDIUM_RESPONSIVE_SIZE = 'medium';
export const SMALL_RESPONSIVE_SIZE = 'small';

// Can't migrate to semantic tokens yet because these colors are used on dnd
// toolbars which are shown over customer content
export const INACTIVE_BORDER_COLOR = '#99acc2'; // FLINT - text-core-disabled
export const INACTIVE_FONT_COLOR = '#99acc2'; // FLINT - text-core-disabled
export const INACTIVE_BACKGROUND_COLOR = '#eaf0f6'; // KOALA - fill-primary-disabled

export const SUBTLE_BORDER_COLOR = '#dfe3eb'; // GREAT_WHITE - border-core-subtle

export const ACTIVE_BORDER_COLOR = '#2d3e50'; // PANTERA
export const ACTIVE_FONT_COLOR = '#ffffff'; // OLAF - text-core-on-fill-default
export const ACTIVE_BACKGROUND_COLOR = '#425b76'; // HEFFALUMP - fill-accent-neutral-default

export const ACTIVE_DROPDOWN_HOVER_BORDER_COLOR = '#2d3e50'; // PANTERA

export const ACTIVE_HOVER_BACKGROUND_COLOR = '#516f90'; // SLINKY - fill-accent-neutral-hover
export const INACTIVE_HOVER_BORDER_COLOR = '#99acc2'; // FLINT - text-core-disabled
export const INACTIVE_HOVER_BACKGROUND_COLOR = '#f5f8fa'; // GYPSUM - fill-tertiary-hover

export const CALYPSO_HANDLE = '#00a4bd'; // CALYPSO - fill-info-default
export const CALYPSO_HANDLE_HOVER = '#0091ae'; // CALYPSO_DARK - text-interactive-default
export const THUNDERDOME_HANDLE = '#6a78d1'; // THUNDERDOME - fill-accent-purple-default
export const SORBET_HANDLE = '#ff8f59'; // SORBET - fill-accent-light-orange-default
export const DANGER_HANDLE = '#f2545b'; // CANDY_APPLE - fill-alert-default
export const DANGER_HANDLE_HOVER = '#d94c53'; // CANDY_APPLE_DARK - fill-alert-pressed
export const INACTIVE_HANDLE_BORDER_COLOR = '#99acc2'; // FLINT - text-core-disabled
export const INACTIVE_HANDLE_BACKGROUND_COLOR = '#99acc2'; // FLINT - text-core-disabled
export const INACTIVE_HANDLE_FONT_COLOR = '#ffffff'; // OLAF - text-core-on-fill-default
export const INACTIVE_HANDLE_HOVER_BACKGROUND_COLOR = '#cbd6e2'; // BATTLESHIP - fill-tertiary-pressed

const TRELLIS_ACTIVE_BACKGROUND_COLOR = '#4d4c4c'; // neutral-900
const TRELLIS_ACTIVE_HOVER_BACKGROUND_COLOR = '#676565'; // neutral-800
const TRELLIS_INACTIVE_BACKGROUND_COLOR = '#ffffff'; // neutral-100
const TRELLIS_INACTIVE_HANDLE_BACKGROUND_HOVER_COLOR = '#676565'; // neutral-800,
const TRELLIS_INACTIVE_HANDLE_BACKGROUND_COLOR = '#8c8787'; // neutral-700,
const TRELLIS_INACTIVE_HOVER_BACKGROUND_COLOR = '#f8f7f6'; // neutral-100
const TRELLIS_ACTIVE_FONT_COLOR = '#f8f7f6'; // neutral-100
const TRELLIS_INACTIVE_FONT_COLOR = '#676565'; // neutral-800
const TRELLIS_ACTIVE_BORDER_COLOR = '#4d4c4c'; // neutral-900
const TRELLIS_INACTIVE_BORDER_COLOR = '#cfcccb'; // neutral-500
const TRELLIS_ACCENT_LIGHT_ORANGE = '#ff4800'; // orange-800, fill-accent-light-orange-default
const TRELLIS_ACCENT_PURPLE = '#6431da'; // purple-1000, fill-accent-purple-default

const baseToolbarVariantStyles = {
  default: {
    backgroundColorActive: ACTIVE_BACKGROUND_COLOR,
    backgroundColorActiveHover: ACTIVE_HOVER_BACKGROUND_COLOR,
    backgroundColorInactive: INACTIVE_BACKGROUND_COLOR,
    backgroundColorInactiveHover: INACTIVE_HOVER_BACKGROUND_COLOR,
    borderColorActive: ACTIVE_BACKGROUND_COLOR,
    borderColorInactive: INACTIVE_BORDER_COLOR,
    fontColorActive: ACTIVE_FONT_COLOR,
    fontColorInactive: INACTIVE_FONT_COLOR
  },
  handle: {
    backgroundColorActive: ACTIVE_BACKGROUND_COLOR,
    backgroundColorActiveHover: ACTIVE_HOVER_BACKGROUND_COLOR,
    backgroundColorInactive: INACTIVE_HANDLE_BACKGROUND_COLOR,
    backgroundColorInactiveHover: INACTIVE_HANDLE_HOVER_BACKGROUND_COLOR,
    borderColorActive: ACTIVE_BACKGROUND_COLOR,
    borderColorInactive: INACTIVE_HANDLE_BORDER_COLOR,
    fontColorActive: ACTIVE_FONT_COLOR,
    fontColorInactive: INACTIVE_HANDLE_FONT_COLOR
  },
  dropdown: {
    backgroundColorActive: ACTIVE_BACKGROUND_COLOR,
    backgroundColorActiveHover: ACTIVE_HOVER_BACKGROUND_COLOR,
    backgroundColorInactive: INACTIVE_BACKGROUND_COLOR,
    backgroundColorInactiveHover: INACTIVE_HOVER_BACKGROUND_COLOR,
    borderColorActive: ACTIVE_DROPDOWN_HOVER_BORDER_COLOR,
    borderColorInactive: INACTIVE_BORDER_COLOR,
    fontColorActive: ACTIVE_FONT_COLOR,
    fontColorInactive: INACTIVE_FONT_COLOR
  },
  primary: {
    backgroundColorActive: CALYPSO_HANDLE,
    backgroundColorActiveHover: CALYPSO_HANDLE_HOVER,
    backgroundColorInactive: INACTIVE_HANDLE_BACKGROUND_COLOR,
    backgroundColorInactiveHover: INACTIVE_HOVER_BACKGROUND_COLOR,
    borderColorActive: CALYPSO_HANDLE,
    borderColorInactive: INACTIVE_HANDLE_BORDER_COLOR,
    fontColorActive: ACTIVE_FONT_COLOR,
    fontColorInactive: INACTIVE_HANDLE_FONT_COLOR
  },
  accentPurple: {
    backgroundColorActive: THUNDERDOME_HANDLE,
    backgroundColorActiveHover: THUNDERDOME_HANDLE,
    backgroundColorInactive: INACTIVE_HANDLE_BACKGROUND_COLOR,
    backgroundColorInactiveHover: INACTIVE_HOVER_BACKGROUND_COLOR,
    borderColorActive: THUNDERDOME_HANDLE,
    borderColorInactive: INACTIVE_HANDLE_BORDER_COLOR,
    fontColorActive: ACTIVE_FONT_COLOR,
    fontColorInactive: INACTIVE_HANDLE_FONT_COLOR
  },
  accentLightOrange: {
    backgroundColorActive: SORBET_HANDLE,
    backgroundColorActiveHover: SORBET_HANDLE,
    backgroundColorInactive: INACTIVE_HANDLE_BACKGROUND_COLOR,
    backgroundColorInactiveHover: INACTIVE_HOVER_BACKGROUND_COLOR,
    borderColorActive: SORBET_HANDLE,
    borderColorInactive: INACTIVE_HANDLE_BORDER_COLOR,
    fontColorActive: ACTIVE_FONT_COLOR,
    fontColorInactive: INACTIVE_HANDLE_FONT_COLOR
  },
  danger: {
    backgroundColorActive: DANGER_HANDLE,
    backgroundColorActiveHover: DANGER_HANDLE_HOVER,
    backgroundColorInactive: INACTIVE_HANDLE_BACKGROUND_COLOR,
    backgroundColorInactiveHover: INACTIVE_HOVER_BACKGROUND_COLOR,
    borderColorActive: DANGER_HANDLE,
    borderColorInactive: INACTIVE_HANDLE_BORDER_COLOR,
    fontColorActive: ACTIVE_FONT_COLOR,
    fontColorInactive: INACTIVE_HANDLE_FONT_COLOR
  }
};
const trellisToolbarVariantStyles = Object.assign({}, baseToolbarVariantStyles, {
  default: {
    backgroundColorActive: TRELLIS_ACTIVE_BACKGROUND_COLOR,
    backgroundColorInactive: TRELLIS_INACTIVE_BACKGROUND_COLOR,
    backgroundColorActiveHover: TRELLIS_ACTIVE_HOVER_BACKGROUND_COLOR,
    backgroundColorInactiveHover: TRELLIS_INACTIVE_HOVER_BACKGROUND_COLOR,
    fontColorActive: TRELLIS_ACTIVE_FONT_COLOR,
    fontColorInactive: TRELLIS_INACTIVE_FONT_COLOR,
    borderColorActive: TRELLIS_ACTIVE_BORDER_COLOR,
    borderColorInactive: TRELLIS_INACTIVE_BORDER_COLOR
  },
  primary: Object.assign({}, baseToolbarVariantStyles.primary, {
    borderColorInactive: TRELLIS_INACTIVE_HANDLE_BACKGROUND_COLOR,
    backgroundColorInactiveHover: TRELLIS_INACTIVE_HANDLE_BACKGROUND_HOVER_COLOR,
    backgroundColorInactive: TRELLIS_INACTIVE_HANDLE_BACKGROUND_COLOR
  }),
  dropdown: Object.assign({}, baseToolbarVariantStyles.dropdown, {
    backgroundColorActive: TRELLIS_ACTIVE_BACKGROUND_COLOR,
    backgroundColorInactive: TRELLIS_INACTIVE_BACKGROUND_COLOR,
    backgroundColorActiveHover: TRELLIS_ACTIVE_HOVER_BACKGROUND_COLOR,
    backgroundColorInactiveHover: TRELLIS_INACTIVE_HOVER_BACKGROUND_COLOR,
    borderColorActive: TRELLIS_ACTIVE_BORDER_COLOR,
    borderColorInactive: TRELLIS_INACTIVE_BORDER_COLOR,
    fontColorActive: TRELLIS_ACTIVE_FONT_COLOR,
    fontColorInactive: TRELLIS_INACTIVE_FONT_COLOR
  }),
  accentLightOrange: Object.assign({}, baseToolbarVariantStyles.accentLightOrange, {
    backgroundColorActive: TRELLIS_ACCENT_LIGHT_ORANGE,
    backgroundColorActiveHover: TRELLIS_ACCENT_LIGHT_ORANGE,
    borderColorActive: TRELLIS_ACCENT_LIGHT_ORANGE
  }),
  accentPurple: Object.assign({}, baseToolbarVariantStyles.accentPurple, {
    backgroundColorActive: TRELLIS_ACCENT_PURPLE,
    backgroundColorActiveHover: TRELLIS_ACCENT_PURPLE,
    borderColorActive: TRELLIS_ACCENT_PURPLE
  })
});
export function getToolbarVariantStyles(isTrellisTheme) {
  return isTrellisTheme ? trellisToolbarVariantStyles : baseToolbarVariantStyles;
}
export const SMALL_CURVE_RADIUS = 3;
export const RESPONSIVE_SIZES = [DEFAULT_RESPONSIVE_SIZE, MEDIUM_RESPONSIVE_SIZE, SMALL_RESPONSIVE_SIZE];

// Copying instead of reusing UIComponent contants, because we only want _corners_ and not plain
// left/right/top/bottom
export const CORNER_PLACEMENTS = ['left top', 'left bottom', 'right top', 'right bottom', 'top left', 'top right', 'bottom left', 'bottom right'];